const FalseCircleCheck = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2627_10078)">
        <circle cx="12" cy="12" r="11.25" stroke="#D9DFE0" strokeWidth="1.5" />
        <path
          d="M10.8696 15.7931C10.479 16.1836 9.84587 16.1836 9.45534 15.7931L6.42183 12.7596C6.1267 12.4644 6.1267 11.9859 6.42183 11.6908V11.6908C6.71695 11.3957 7.19545 11.3957 7.49058 11.6908L9.45534 13.6556C9.84587 14.0461 10.479 14.0461 10.8696 13.6556L16.5093 8.01582C16.8045 7.72069 17.2829 7.72069 17.5781 8.01582V8.01582C17.8732 8.31095 17.8732 8.78944 17.5781 9.08457L10.8696 15.7931Z"
          fill="#D9DFE0"
        />
      </g>
      <defs>
        <clipPath id="clip0_2627_10078">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FalseCircleCheck;
